import React, { useEffect, useRef } from 'react';
import TabPanel from './TabPanel';
import styles from './TabMenuList.module.css';
import useTabMenu from 'e3-common/hooks/useTabMenu';
import { HOME_MENU_ID } from 'e3-common/constants/constMenuId';
import { LOCAL_STORAGE_KEYS } from 'e3-common/constants/enumerates';
import { setLocalStorageItem } from 'e3-common/utils/localStorageUtil';
import { useBoundStore } from 'e3-common/store/useBoundStore';

import { shallow } from 'zustand/shallow';
import { useNavigate } from 'react-router-dom';
import { findTopMenu } from 'e3-common/utils/menuUtil';

const TabMenuList = () => {
    const { menuList, changeTab, prevTab, nextTab, closeTab, closeAllTab } = useTabMenu();
    const { setSelectedMenu, setSelectedTopMenu } = useBoundStore((state) => state.menu, shallow);
    const menuListAll = useBoundStore((state) => state.menu.menuList, shallow);

    const tabScrollRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const el = tabScrollRef.current;
        if (el) {
            const onWheel = (e) => {
                if (e.deltaY == 0) return;
                e.preventDefault();
                el.scrollTo({
                    left: el.scrollLeft + e.deltaY,
                    // behavior: 'smooth',
                });
            };
            el.addEventListener('wheel', onWheel);
            return () => el.removeEventListener('wheel', onWheel);
        }
    }, []);

    return (
        // <div style={{flexGrow:'1'}}>
        <>
            <div className={styles.tab}>
                <div ref={tabScrollRef} className={styles.tabMenu}>
                    <ul>
                        {menuList.map((e) => (
                            <li key={e.menuId} className={e.selected ? styles.selected : ''}>
                                <a
                                    key={e.menuId + 1}
                                    onClick={() => {
                                        // 그리드 개인화 기능을 위한 메뉴ID 인식
                                        setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, e.menuId);

                                        const topMu = findTopMenu(menuListAll, e.menuId);

                                        setSelectedTopMenu({
                                            menuId: topMu?.menuId,
                                            menuName: topMu?.menuName,
                                            helpYn: topMu?.helpYn,
                                            sideYn: 'Y',
                                            displayYn: 'Y',
                                            menuNameList: topMu?.menuNameList,
                                        });

                                        setSelectedMenu({
                                            menuId: e.menuId,
                                            menuName: e.menuName,
                                            helpYn: e.helpYn,
                                            sideYn: 'Y',
                                            displayYn: 'Y',
                                            menuNameList: e.menuNameList,
                                        });

                                        changeTab(e.menuId);
                                    }}
                                    className={`${e.menuId === HOME_MENU_ID ? styles.home : ''}`}
                                >
                                    {e.menuId === HOME_MENU_ID ? null : e.menuName}
                                </a>
                                {e.menuId === HOME_MENU_ID ? null : (
                                    <a
                                        key={e.menuId + 2}
                                        className={styles.close}
                                        onClick={() => {
                                            closeTab(e.menuId);
                                        }}
                                    >
                                        닫기
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.tabControl}>
                    <a className={styles.prev} onClick={prevTab}>
                        이전
                    </a>
                    <a className={styles.next} onClick={nextTab}>
                        다음
                    </a>
                    <a className={styles.allClose} onClick={closeAllTab}>
                        전체 닫기
                    </a>
                </div>
            </div>

            {/* 즐겨찾기 선택시 selected 추가 */}
            {menuList?.map((e) => (
                <TabPanel key={e.menuId} menuItem={e} />
            ))}
            {/* <Footer /> */}
        </>
    );
};

export default TabMenuList;
